import Report from './index'
import ReportData from './components/reportData/reportData.vue'
export default [
  {
    path: '/reports',
    component: Report
  },
  {
    path: '/reports/entry',
    name: '/reports/entry',
    component: ReportData,
    props: (route) => ({
      reportId: route.query.id,
      mode: route.params.mode
    })
  }
]
